import React from 'react'
// libs
import styled from 'styled-components'
import { useDispatch } from 'react-redux'
import { InjectedFormProps, reduxForm, submit } from 'redux-form'
// constants
import { Forms } from 'constants/forms'
// types
import { IObjectEntityReviewQuestion } from 'types/graphql'
// components
import { ReduxInput } from 'components/FormElements'
// utils
import { debounce } from 'lodash'
import { required } from 'utils/validators'

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`

type Fields = Record<string, string>

interface Props {
  questions: IObjectEntityReviewQuestion[]
}

const ReviewQuestionsForm: React.FC<InjectedFormProps<Fields> & Props> = ({ questions, handleSubmit }) => {
  const dispatch = useDispatch()

  const onChange = React.useCallback(
    debounce(() => dispatch(submit(Forms.OBJECT_REVIEW_QUESTIONS_FORM)), 1000),
    []
  )

  return (
    <Form onSubmit={handleSubmit}>
      <ReduxInput
        multiline
        label='Question 1'
        validate={[required]}
        name={questions[0].id}
        handleInputChange={onChange}
      />
      <ReduxInput
        multiline
        label='Question 2'
        validate={[required]}
        name={questions[1].id}
        handleInputChange={onChange}
      />
      <ReduxInput
        multiline
        label='Question 3'
        validate={[required]}
        name={questions[2].id}
        handleInputChange={onChange}
      />
    </Form>
  )
}

export default reduxForm<any, any>({
  form: Forms.OBJECT_REVIEW_QUESTIONS_FORM,
  enableReinitialize: false
})(ReviewQuestionsForm)
